<script lang="ts">
    import ClickAction from '~/components/jet/action/ClickAction.svelte';

    export let item;

    $: clickAction = item.segue;
    $: title = item.title;
</script>

<div class="link-lockup">
    <ClickAction action={clickAction}>
        <span class="link-lockup__title">{title}</span>
    </ClickAction>
</div>

<style lang="scss">
    @use 'amp/stylekit/core/mixins/line-clamp' as *;

    .link-lockup {
        color: var(--keyColor);

        :global(.click-action) {
            display: flex;
            align-items: center;
            height: 48px;
        }
    }

    .link-lockup__title {
        font: var(--title-2);

        @include line-clamp(1);
    }
</style>
